import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DynamicFormsService } from './dynamic-forms.service';

// This service is used to retireve information from the server when a route changes
@Injectable()
export class DynamicFormsResolver implements Resolve<any> {
  constructor(private dynamicFormsService: DynamicFormsService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const forms: string[] = route.data.forms;
    const forms$ = [];

    forms?.forEach(form => forms$.push(this.dynamicFormsService.getFormGroupForModel(form)));

    return forkJoin(forms$);
  }
}
